import { gql } from '@apollo/client';

export const UPSERT_CAP = gql`
  mutation (
    $jobId: Int!
    $clientId: String
    $findings: [CapFindingInputObject!]
    $actionType: String!
  ) {
    UpsertCap(
      jobId: $jobId
      clientId: $clientId
      findings: $findings
      actionType: $actionType
    ) {
      success
      error
      }
    }
`;

export const UPSERT_CAP_FINDING = gql`
  mutation(
    $id: Int!
    $dueDate: DateTime
    $responsiblePerson: String
    $rootCause: String
    $status: String
    $statusNotes: String
    $evidenceReviewRequired: Boolean
  ) {
    CapUpsertFinding(
      id: $id
      dueDate: $dueDate
      responsiblePerson: $responsiblePerson
      rootCause: $rootCause
      status: $status
      statusNotes: $statusNotes
      evidenceReviewRequired: $evidenceReviewRequired
    ) {
      finding {
        id
        dueDate
        responsiblePerson
        rootCause
        status
        statusDate
        statusNotes
        statusUpdatedByUser {
          firstName
          lastName
        }
        evidenceReviewRequired
      }
    }
  }
`;

export const CAP_ACTION_DELETE_MUTATION = gql`
  mutation CapDeleteAction($id: Int!) {
    CapDeleteAction(
      id: $id
    ) {
      status
    }
  }
`;

export const UPSERT_CAP_ACTION = gql`
  mutation(
    $id: Int
    $findingId: Int
    $rootCause: String
    $actionType: String
    $actionTaken: String
    $facilityContact: String
    $actualCompletionOfActionDate: DateTime
    $reviewNotes: String
    $statusNotes: String
    $status: String
    $dueDate: DateTime
    $attachmentIds: [Int!]
    $attachmentsMeta: [AttachmentsInputObject!]
  ) {
    CapUpsertAction(
      id: $id
      findingId: $findingId
      rootCause: $rootCause
      actionType: $actionType
      actionTaken: $actionTaken
      facilityContact: $facilityContact
      actualCompletionOfActionDate: $actualCompletionOfActionDate
      reviewNotes: $reviewNotes
      statusNotes: $statusNotes
      status: $status
      dueDate: $dueDate
      attachmentIds: $attachmentIds
      attachmentsMeta: $attachmentsMeta
    ) {
      action {
        id
        actionReference
        rootCause
        actionType
        actionTaken
        dueDate
        facilityContact
        actualCompletionOfActionDate
        reviewedDate
        reviewedBy
        reviewedByUser {
          lastName
          firstName
        }
        reviewNotes
        status
        statusNotes
        statusDate
        statusUpdatedBy
        statusUpdatedByUser {
          lastName
          firstName
        }
        attachmentIds
        attachmentsMeta {
          name
          size
          type
          attId
          filePath
        }
        resources {
          id
          actionId
          resourceType
          frequency
          basis
          staffType
          staffDayType
          staffDayValue
          numberOfStaffDays
          currencyId
          costs
          details
        }
      }
    }
  }
`;

export const UPDATE_OVERALL_CAP_STATUS = gql`
  mutation (
    $jobId: Int!
    $overallCapStatus: String
  ) {
    UpdateOverallCapStatus(
      jobId: $jobId
      overallCapStatus: $overallCapStatus
    ) {
      success
    }
  }
`;

export const UPSERT_ACTION_RESOURCE = gql`
  mutation CapUpsertActionResource(
    $id: Int
    $actionId: Int!
    $resourceType: String!
    $frequency: String!
    $basis: String
    $staffType: String
    $staffDayType: String
    $staffDayValue: Float
    $currencyId: Int
    $costs: Float
    $details: String
  ) {
    CapUpsertActionResource(
      id: $id
      actionId: $actionId
      resourceType: $resourceType
      frequency: $frequency
      basis: $basis
      staffType: $staffType
      staffDayType: $staffDayType
      staffDayValue: $staffDayValue
      currencyId: $currencyId
      costs: $costs
      details: $details
    ) {
      actionResource {
        id
        actionId
        resourceType
        frequency
        basis
        staffType
        staffDayType
        staffDayValue
        numberOfStaffDays
        currencyId
        costs
        details
      }
    }
  }
`;

export const DELETE_CAP_ACTION_RESOURCE = gql`
  mutation CapDeleteActionResource(
    $id: Int!
  ) {
    CapDeleteActionResource(
      id: $id
    ) {
      status
    }
  }
`;

export const EXPORT_CAP = gql`
  mutation exportCap(
    $jobId: Int!
    $findingsInfo: [FindingCapInfoInputObject!]
  ) {
    exportCap(
      jobId: $jobId
      findingsInfo: $findingsInfo
    ) {
      pdfBase64
    }
  }
`;

export const EXPORT_CAP_NEW = gql`
  mutation exportCapNew(
    $jobId: Int!
    $findingsInfo: [FindingCapInfoInputObject!]
  ) {
    exportCapNew(
      jobId: $jobId
      findingsInfo: $findingsInfo
    ) {
      pdfBase64
    }
  }
`;